export default __webpack_public_path__ + "static/media/tripCancelledIcon.4fbe9f8a.svg";